function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { cloneElement, isValidElement, useState } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../../utils/classNames';
/**
 * The SlimTile component provides an alternative composition of ProductTile content
 *
 * - [DIG20 ATLAS spec](https://atlas.np.tools.playstation.net/design/2ae41adf-6120-4bf2-9a15-8b187f84fd03/8?bounds=-1.500,3.051,4.000,1.661)
 */

var Wrapper = function Wrapper(props) {
  return /*#__PURE__*/React.createElement("div", props);
};

var wrapper = /*#__PURE__*/React.createElement(Wrapper, null);

var SlimTile = function SlimTile(_ref) {
  var BaseComponent = _ref.as,
      className = _ref.className,
      disabled = _ref.disabled,
      discountBadge = _ref.discountBadge,
      gameArt = _ref.gameArt,
      secondaryMeta = _ref.secondaryMeta,
      platformTags = _ref.platformTags,
      price = _ref.price,
      title = _ref.title,
      qa = _ref.qa,
      serviceUpsell = _ref.serviceUpsell,
      type = _ref.type,
      accessoryCta = _ref.accessoryCta,
      progress = _ref.progress,
      textLink = _ref.textLink,
      interactiveComponent = _ref.interactiveComponent;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var _SlimTile$getClassNam = SlimTile.getClassName({
    className: className,
    disabled: disabled,
    isFocused: isFocused,
    hasInteractiveComponent: !!interactiveComponent
  }),
      root = _SlimTile$getClassNam.root,
      gameArtSpacer = _SlimTile$getClassNam.gameArtSpacer,
      gameArtLoading = _SlimTile$getClassNam.gameArtLoading,
      gameArtClass = _SlimTile$getClassNam.gameArt,
      productInfoClass = _SlimTile$getClassNam.productInfo,
      titleClass = _SlimTile$getClassNam.title,
      productMetaClass = _SlimTile$getClassNam.productMeta,
      secondaryMetaClass = _SlimTile$getClassNam.secondaryMeta,
      discountBadgeClass = _SlimTile$getClassNam.discountBadge,
      priceClass = _SlimTile$getClassNam.price,
      priceMetaClass = _SlimTile$getClassNam.priceMeta,
      progressContainer = _SlimTile$getClassNam.progressContainer,
      textLinkContainer = _SlimTile$getClassNam.textLinkContainer,
      accessoryCtaContainer = _SlimTile$getClassNam.accessoryCtaContainer,
      allyIndicator = _SlimTile$getClassNam.allyIndicator,
      interactiveComponentRoot = _SlimTile$getClassNam.interactiveComponentRoot,
      interactiveComponentUnderlay = _SlimTile$getClassNam.interactiveComponentUnderlay;

  var isConcept = type === 'CONCEPT';
  var x = interactiveComponent || wrapper;

  var ResponsiveProgressCta = function ResponsiveProgressCta(props) {
    var _progress$props;

    var progressCta = progress === null || progress === void 0 ? void 0 : (_progress$props = progress.props) === null || _progress$props === void 0 ? void 0 : _progress$props.cta;
    if (!progressCta || ! /*#__PURE__*/isValidElement(progressCta)) return null;
    return /*#__PURE__*/React.createElement("span", {
      className: "psw-l-exclude@below-tablet-s psw-l-space-x-3"
    }, /*#__PURE__*/cloneElement(progressCta, props));
  };

  return /*#__PURE__*/React.createElement(BaseComponent, {
    "data-qa": qa,
    className: root
  }, /*#__PURE__*/React.createElement("div", {
    className: gameArtSpacer
  }), /*#__PURE__*/React.createElement("div", {
    className: productInfoClass
  }, /*#__PURE__*/cloneElement(x, {
    variant: 'content',
    className: interactiveComponentRoot,
    disabled: disabled,
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: allyIndicator
  }), /*#__PURE__*/React.createElement("div", {
    className: interactiveComponentUnderlay
  }, /*#__PURE__*/React.createElement("div", {
    className: gameArtLoading
  }), /*#__PURE__*/React.createElement("div", {
    className: gameArtClass
  }, gameArt && /*#__PURE__*/cloneElement(gameArt, {
    qa: "".concat(qa, "#game-art"),
    disabled: disabled,
    cornerRadius: 'none',
    interactive: !!interactiveComponent
  }))), /*#__PURE__*/React.createElement("div", {
    className: "psw-fill-x"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: titleClass,
    "data-qa": "".concat(qa, "#title")
  }, title), secondaryMeta && /*#__PURE__*/React.createElement("div", {
    className: secondaryMetaClass,
    "data-qa": "".concat(qa, "#meta2")
  }, secondaryMeta), (!!platformTags || !!serviceUpsell) && /*#__PURE__*/React.createElement("div", {
    className: productMetaClass
  }, platformTags && /*#__PURE__*/cloneElement(platformTags, {
    qa: "".concat(qa, "#platform-tags"),
    disabled: disabled
  }), serviceUpsell && /*#__PURE__*/cloneElement(serviceUpsell, {
    qa: "".concat(qa, "#service-upsell"),
    variant: 'tag',
    disabled: disabled
  })), !!price && /*#__PURE__*/React.createElement("div", {
    className: priceMetaClass
  }, !isConcept && discountBadge && /*#__PURE__*/cloneElement(discountBadge, {
    className: discountBadgeClass,
    qa: "".concat(qa, "#discount-badge"),
    disabled: disabled
  }), price && /*#__PURE__*/cloneElement(price, {
    className: priceClass,
    qa: "".concat(qa, "#price"),
    disabled: disabled
  }))))), !!progress && /*#__PURE__*/React.createElement("div", {
    className: progressContainer
  }, /*#__PURE__*/cloneElement(progress, {
    qa: "".concat(qa, "#progress"),
    disabled: disabled,
    completeness: /*#__PURE__*/React.createElement("span", {
      className: "psw-l-exclude@below-tablet-s"
    }, progress.props.completeness // We need to ensure space is preserved for completeness in the event it is not
    // provided because we adjust the progress position based on the completeness
    // line height
    ||
    /*#__PURE__*/
    React.createElement("span", null, "\xA0")),
    cta: /*#__PURE__*/React.createElement(ResponsiveProgressCta, null)
  })), !!textLink && /*#__PURE__*/React.createElement("div", {
    className: textLinkContainer
  }, /*#__PURE__*/cloneElement(textLink, {
    qa: "".concat(qa, "#textLink"),
    disabled: disabled
  }))), !!accessoryCta && /*#__PURE__*/React.createElement("div", {
    className: accessoryCtaContainer
  }, /*#__PURE__*/cloneElement(accessoryCta, {
    qa: "".concat(qa, "#accessoryCta"),
    disabled: disabled
  })));
};

var cx = classNamesFor(SlimTile);

SlimTile.getClassName = function (_ref2) {
  var className = _ref2.className,
      disabled = _ref2.disabled,
      isFocused = _ref2.isFocused,
      hasInteractiveComponent = _ref2.hasInteractiveComponent;
  var imageSize = 'psw-icon-size-6';
  var gameArt = ['psw-l-anchor-center-left', 'psw-l-center-left', imageSize];
  return {
    root: cx('psw-slim-tile', 'psw-l-line-left', 'psw-r-2', 'psw-l-anchor', 'psw-p-r-5', 'psw-l-z-1', 'psw-c-bg-1', 'psw-fill-x', className),
    gameArtSpacer: cx(imageSize),
    gameArt: cx(gameArt),
    gameArtLoading: cx(gameArt, 'psw-loading-block'),
    productInfo: cx('psw-l-stack-left', 'psw-fill-x', 'psw-p-l-5'),
    title: cx('psw-l-anchor', 'psw-t-body', "psw-c-t-".concat(disabled ? 'disabled' : '1'), 'psw-t-truncate-2', 'psw-m-b-3'),
    productMeta: cx('psw-l-anchor', 'psw-l-line-left', 'psw-l-cluster', 'psw-l-gap-2', 'psw-m-b-3'),
    priceMeta: cx('psw-l-line-center'),
    secondaryMeta: cx('psw-l-anchor', "psw-c-t-".concat(disabled ? 'disabled' : '2'), 'psw-t-secondary', 'psw-m-b-3'),
    discountBadge: cx('psw-m-r-3'),
    price: cx('psw-l-anchor', 'psw-fill-x'),
    progressContainer: cx('psw-slim-tile-progress', 'psw-l-anchor', 'psw-fill-x', 'psw-l-line-left', 'psw-p-b-2'),
    textLinkContainer: cx('psw-l-anchor', 'psw-l-line-left', 'psw-p-b-1'),
    accessoryCtaContainer: cx('psw-l-anchor', 'psw-l-inline', 'psw-l-z-15', 'psw-m-l-4'),
    interactiveComponentRoot: cx(hasInteractiveComponent && 'psw-interactive-root', 'psw-l-line-left', 'psw-fill-x', 'psw-l-static'),
    allyIndicator: cx('psw-l-anchor-center', 'psw-fill', 'psw-r-2', 'psw-ally-indicator', 'psw-ally-indicator-gap-1', 'psw-show-on-hover', 'psw-b-0', isFocused && 'psw-is-focused', disabled && 'psw-is-disabled'),
    interactiveComponentUnderlay: cx('psw-l-anchor-center', 'psw-fill', 'psw-clip', 'psw-r-2', hasInteractiveComponent && cx('psw-c-bg-interactive-1'), isFocused && 'psw-is-focused', disabled && 'psw-is-disabled')
  };
};

SlimTile.defaultProps = {
  as: 'div',
  className: '',
  disabled: false,
  discountBadge: null,
  secondaryMeta: '',
  platformTags: null,
  price: null,
  qa: '',
  serviceUpsell: null,
  accessoryCta: null,
  progress: null,
  textLink: null,
  interactiveComponent: null
};
SlimTile.propTypes = {
  /**
   * Sets the element type of the SlimTile root
   */
  as: PropTypes.elementType,

  /**
   * Add custom classes to SlimTile
   */
  className: PropTypes.string,

  /**
   * Set disabled state
   */
  disabled: PropTypes.bool,

  /**
   * Include an instance of <DiscountBadge /> here as needed
   */
  discountBadge: PropTypes.element,

  /**
   * Requires <GameArt /> to display the product image
   */
  gameArt: PropTypes.element.isRequired,

  /**
   * Last played, Game Size, Game Information metadata, Human readable string,
   * e.g. "Played: Yesterday"
   */
  secondaryMeta: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),

  /**
   * Optional <PlatformTags /> to display alongside the image
   */
  platformTags: PropTypes.element,

  /**
   * Include an instance of <Price /> here as needed
   */
  price: PropTypes.element,

  /**
   * Title, generally the required name of a product / game
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]).isRequired,

  /**
   * The qa selector to set for the instance of the component
   */
  qa: PropTypes.string,

  /**
   * Include <ServiceUpsell /> to display alongside the PlatformTags
   */
  serviceUpsell: PropTypes.element,

  /**
   * Type of product
   */
  type: PropTypes.oneOf(['PRODUCT', 'CONCEPT']).isRequired,

  /**
   * Provides secondary actions for a given slim tile
   */
  accessoryCta: PropTypes.element,

  /**
   * Progress component representing the (download) progress of a given entitlement. There should
   * be no case where accessoryCta and progress and textLink appear together.
   */
  progress: PropTypes.element,

  /**
   * Link component or equivalent for providing an additional link. There should
   * be no case where accessoryCta and progress and textLink appear together.
   */
  textLink: PropTypes.element,

  /**
   * The instance of a react component (i.e. Link, Button) makes the slim tile interactable.
   */
  interactiveComponent: PropTypes.element
};
export default SlimTile;